import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/auth/store";
import Roles from "./modules/roles/store";
import Modules from "./modules/rolemodules/store";
import Permissions from "./modules/permissions/store";
import Users from "./modules/users/store";
import UserRoles from "./modules/userroles/store";
import userProfile from "./modules/userprofile/store";
import products from "./modules/products/store";
import stocks from "./modules/stocks/store";
import deadstocks from "./modules/deadstocks/store";
import transporters from "./modules/transporters/store";
import trucks from "./modules/trucks/store";
import suppliers from "./modules/suppliers/store";
import accounttypes from "./modules/accounttypes/store";
import pettycashes from "./modules/pettycashes/store";
import purchaseorders from "./modules/purchaseorders/store";
import goodsreceiving from "./modules/goodsreceiving/store";
import purchases from "./modules/purchases/store";
import sales from "./modules/sales/store";
import deadsales from "./modules/deadsales/store";
import expenses from "./modules/expenses/store";
import reports from "./modules/reports/store";
import labours from "./modules/labours/store";
import oils from "./modules/oils/store";
import interchanges from "./modules/interchanges/store";
import employees from "./modules/employees/store";
import occupations from "./modules/occupations/store";
import attendances from "./modules/attendances/store";
import invoices from "./modules/invoices/store";
import numberlesslabours from "./modules/numberlesslabours/store";
import employeedeductions from "./modules/employeedeductions/store";
import mileages from "./modules/mileages/store";
import cfs from "./modules/cfs/store";
import destinations from "./modules/destinations/store";
import jobcards from "./modules/jobcards/store";
import truckattendances from "./modules/truckattendances/store";
import drivers from "./modules/drivers/store";
import truckdocuments from "./modules/truckdocuments/store";
import trips from "./modules/trips/store";
import consignees from "./modules/consignees/store";
import fuels from "./modules/fuels/store";
import stations from "./modules/stations/store";
import commissions from "./modules/commissions/store";
import parkings from "./modules/parkings/store";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    Roles,
    Modules,
    Permissions,
    Users,
    UserRoles,
    userProfile,
    products,
    stocks,
    deadstocks,
    transporters,
    trucks,
    suppliers,
    accounttypes,
    pettycashes,
    purchaseorders,
    goodsreceiving,
    purchases,
    sales,
    deadsales,
    expenses,
    reports,
    labours,
    oils,
    interchanges,
    employees,
    occupations,
    attendances,
    invoices,
    numberlesslabours,
    employeedeductions,
    mileages,
    cfs,
    destinations,
    jobcards,
    truckattendances,
    drivers,
    truckdocuments,
    trips,
    consignees,
    fuels,
    stations,
    commissions,
    parkings
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js